//计划状态
const adsetStatus = [
  { value: "AD_STATUS_NORMAL", label: "启用中" },
  { value: "AD_STATUS_SUSPEND", label: "暂停中" },
  { value: "AD_STATUS_DELETED", label: "已删除" },
];

export default {
  adsetStatus,
};
